import { createClearisticTheme } from './createClearisticTheme';

/**
 * Clearistic light theme.
 *
 * Colours come from `clearisticPalette`; the shape of the theme comes from
 * `createClearisticTheme`, which builds both modes so they cannot drift apart.
 */
export const clearisticTheme = createClearisticTheme('light');
